import config from "../../config";
import { LRORequestPost } from "../api/LRORequest";

const generateCaseDetailLetter = (formData) => {
  return LRORequestPost(`${config.BASE_URL}update-case`, {
    requestMode: 'async',
    formData: formData,
  });
};

export default generateCaseDetailLetter;
